export default __webpack_public_path__ + "static/media/a011-PPII-2.2bf05b76.svg";